
  import Chart, { ChartData, ChartOptions } from 'chart.js'
  import {
    defineComponent,
    onMounted,
    onUnmounted,
    PropType,
    ref,
    watch,
    toRefs
  } from 'vue'

  export default defineComponent({
    props: {
      type: String,

      data: {
        type: Object as PropType<ChartData>,
        requred: true
      },
      options: {
        type: Object as PropType<ChartOptions>,
        requred: true
      }
    },

    setup(opts) {
      const { type } = toRefs(opts)
      const { data } = toRefs(opts)
      const canvasElem = ref<HTMLCanvasElement>()
      var myChart: Chart

      onMounted(() => {
        var ctx = canvasElem.value.getContext('2d')
        myChart = new Chart(ctx, {
          type: opts.type,
          data: opts.data,
          options: opts.options
        })
        myChart.canvas.style.fillOpacity = 'none'
        ctx.canvas.style.borderColor = 'white'
        ctx.canvas.style.fill = 'false'
        myChart.canvas.style.fill = 'false'
        ctx.canvas.style.backgroundColor = 'white'
      })

      watch(type, () => {
        var ctx = canvasElem.value.getContext('2d')
        if (myChart) {
          myChart.destroy()
        }
        myChart = new Chart(ctx, {
          type: opts.type,
          data: opts.data,
          options: opts.options
        })
        ctx.canvas.style.fill = 'false'
        myChart.canvas.style.fill = 'false'
      })
      watch(data, () => {
        var ctx = canvasElem.value.getContext('2d')
        if (myChart) {
          myChart.destroy()
        }
        myChart = new Chart(ctx, {
          type: opts.type,
          data: opts.data,
          options: opts.options
        })
      })

      onUnmounted(() => {
        if (myChart) {
          myChart.destroy()
        }
      })

      return {
        canvasElem
      }
    }
  })
